import React from "react";
import Button from "../../../../../components/form-control/Button";
import { Claim } from "../../../../../models/claim/Claim";
import { CLAIM_STAGES } from "../../../../../resources/enums";
import { updateClaimStage } from "../../../../../api/requests";
import { approveNonMotorClaimAndSubmitToInsurer, updateNonMotorClaimStage } from "../../../../../services/claims";
import { showToast } from "../../../../../utils/miscFunctions";

type IUpdateClaimSTageModalProps = {
    claim: Claim | undefined;
    onSubmitted: () => void;
    onCancel: () => void;
    stage: CLAIM_STAGES;
    type: 'motor' | 'non-motor';
};

const UpdateClaimSTageModal = ({ claim, onSubmitted, onCancel, stage, type }: IUpdateClaimSTageModalProps) => {
    const isNonMotor = type === 'non-motor'
    const [submitting, setSubmitting] = React.useState<boolean>(false);

    const submitClaim = async () => {
        if (!claim?.claimNumber) return;
        setSubmitting(true);

        try {
            if (isNonMotor && stage === CLAIM_STAGES.SUBMITTED) {
                const response: any = await approveNonMotorClaimAndSubmitToInsurer(claim?.claimNumber ?? "", null)
                if (response) {
                    showToast.success(response?.message || "Good job. Claim stage updated successfully.")
                    onSubmitted();
                }
            }
            else {
                const response: any = isNonMotor ? await updateNonMotorClaimStage(claim?.claimNumber ?? "", stage) : await updateClaimStage(claim?.claimNumber ?? "", stage)
                if (response) {
                    showToast.success(response?.message || "Good job. Claim stage updated successfully.")
                    onSubmitted();
                }
            }
        } catch (error: any) {
            showToast.error(error?.description || "Failed to update claim stage. Please try again later.");
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="bg-white dark:bg-darkBg">
            <div className="p-4 space-y-10">
                <div className="pt-6 dark:text-darkBg-mainText">
                    <p>By submitting this claim, you agree that all of the details
                        provided by the claim&apos;s owner is accurate as of this day. Do you
                        agree to submit this?
                    </p>
                </div>

                <div className="flex justify-end space-x-6">
                    <Button
                        label="Cancel"
                        className="w-fit px-8 h-[45px] rounded-[5px] text-base border-[1px] border-primary-main"
                        onClick={onCancel}
                    />
                    <Button
                        label="Submit"
                        className="bg-primary-main w-fit px-8 py-2 h-[45px] rounded-[5px] text-base"
                        onClick={submitClaim}
                        loading={submitting}
                        disabled={submitting}
                    />
                </div>
            </div>
        </div>
    );
};

export default UpdateClaimSTageModal;